import { render, staticRenderFns } from "./CreateNewButton.vue?vue&type=template&id=855dc916&scoped=true&"
import script from "./CreateNewButton.vue?vue&type=script&lang=js&"
export * from "./CreateNewButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "855dc916",
  null
  
)

export default component.exports